// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"643":"0e55d33c","685":"e298b8e6","843":"61d80c6b","913":"d6aaf762"}[chunkId] + ".css";
};